<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="学习时间：" class="m-l-14">
      <el-date-picker
        v-model="timeRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.lectureName"
        placeholder="姓名/学习名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      auditStatusList: [],
      timeRange: [],
    };
  },
  created() {
    this.getSysParamByTypes(["TOPICLECTURE_AUDIT"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["TOPICLECTURE_AUDIT"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusList = res.data["TOPICLECTURE_AUDIT"] || [];
      });
    },
    initData() {
      let startTime = "";
      let endTime = "";
      if (this.timeRange && this.timeRange.length > 0) {
        startTime = this.timeRange[0];
        endTime = this.timeRange[1];
      }
      this.$emit("search", {
        ...this.filters,
        lectureStartTime: startTime,
        lectureEndTime: endTime,
        t: new Date().getTime(),
      });
    },
    resetData() {
      this.timeRange = [];
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
